module.exports = __webpack_public_path__ + "img/FILTER.4b897ee2.svg";